<template>
	<div>
		<div class="orgInfo">
			<a-form layout="inline" class="pad-x15 pad-y20 pad-b15 form-label-auto">
				<a-form-item label="组织名称" class="width-normal">
					<a-input v-model:value="orgForm.orgName" placeholder="输入组织名称" />
				</a-form-item>
				<a-form-item label="状态" class="width-normal">
					<a-select ref="select" v-model:value="orgForm.orgStatus" placeholder="选择状态">
						<a-select-option value="1">启用</a-select-option>
						<a-select-option value="0">禁用</a-select-option>
					</a-select>
				</a-form-item>
				<a-form-item><a-space :size="8">
						<a-button type="primary" @click="btnSearch"><i class="el-icon-search"></i> 查询</a-button>
						<a-button @click="btnReset"><i class="el-icon-refresh"></i> 重置</a-button>
						<a-button type="primary" @click="handleMaintain('add')"><i class="el-icon-plus"></i> 新增组织
						</a-button>
					</a-space>
				</a-form-item>
			</a-form>
		</div>
		<!-- table -->
		<div class="tableInit">
			<a-table :dataSource="dataSource" :columns="columns" :rowKey="(record) => record.id" childrenColumnName="child">
				<template v-slot:actionStatus="actionStatus">
					<a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="actionStatus.record.status"
						checked-children="正常" un-checked-children="禁用" @change="maintainStatus(actionStatus.record)" />
				</template>
				<template v-slot:actionTags="actionTags">
					<a-button type="primary" size="small" @click="handleMaintain('edit', actionTags.record)">
						编辑
					</a-button>
					<a-popconfirm title="确定删除吗？该删除不会撤销" ok-text="是" cancel-text="否" @confirm="handleDelete(actionTags.record)">
						<a-button type="primary" danger size="small" v-show="actionTags.record.child.length < 1">
							删除
						</a-button>
					</a-popconfirm>
				</template>
			</a-table>
		</div>

		<a-modal v-model:visible="showOrgMaintain" :title="isaddedit ? '添加组织' : '编辑组织'" @ok="maintainOrg('menu')"
			autocomplete="off" centered>
			<a-form :model="maintianForm" ref="orgRuls">
				<a-form-item label="上级组织" name="parent" :rules="[{ required: true, message: '选择上级组织!' }]">
					<a-tree-select v-model:value="maintianForm.parent" placeholder="请选择上级菜单" show-Line="true"
						:tree-data="dataSource" @change="orgChange" :replace-fields="{
		        children: 'child',
		        label: 'name',
		        key: 'id',
		        value: 'id',
		      }">
					</a-tree-select>
				</a-form-item>
				<a-form-item label="组织类型" name="type" has-feedback :rules="[{ required: true, message: '输入所在地区!' }]">
					<!-- 1体育局2运动中心3场馆 -->
					<a-radio-group v-model:value="maintianForm.type" name="radioGroup" :disabled="!isaddedit">
						<a-radio value="1" :disabled="
		          maintianForm.parentType == 2 || maintianForm.parentType == 3
		        ">体育局</a-radio>
						<a-radio value="2" :disabled="maintianForm.parentType == 3">运动中心</a-radio>
						<a-radio value="3" :disabled="maintianForm.parentType == 2">场馆</a-radio>
					</a-radio-group>
				</a-form-item>
				<a-form-item label="组织名称" name="name" has-feedback :rules="[{ required: true, message: '输入组织名称!' }]">
					<a-input v-model:value="maintianForm.name" placeholder="输入菜单名称 " />
				</a-form-item>
				<a-form-item label="状态" name="status" :rules="[{ required: true, message: '请选择状态!' }]">
					<a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="maintianForm.status" checked-children="启用"
						un-checked-children="禁用" />
				</a-form-item>
				<a-form-item label="所在地区" has-feedback :rules="[{ required: true, message: '输入所在地区!' }]">
					<AdministrativeArea v-if="showOrgMaintain" @callBackTreeValue="orgFormTreeValue"
						:treeNodeVal="maintianForm.address" />
				</a-form-item>
				<a-form-item label="详细地址" name="detailAddress" has-feedback :rules="[{ required: true, message: '输入详细地址!' }]">
					<!-- 类型1目录2菜单3按钮 -->
					<a-textarea v-model:value="maintianForm.detailAddress" placeholder="输入详细地址" show-count :maxlength="200" />
				</a-form-item>
				<a-form-item label="联系人">
					<a-input v-model:value="maintianForm.contacts" placeholder="输入联系人姓名" />
				</a-form-item>
				<a-form-item label="联系电话">
					<a-input v-model:value="maintianForm.contactNumber" placeholder="输入联系电话" auto-size />
				</a-form-item>
			</a-form>
		</a-modal>
	</div>

</template>

<script>
	const columns = [{
			title: "  ",
			dataIndex: "num",
			key: "num",
			align: "center",
			width: 80,
		},
		{
			title: "组织名称",
			dataIndex: "name",
			key: "name",
			align: "center",
		},
		{
			title: "所在地区",
			dataIndex: "addressName",
			key: "addressName",
			align: "center",
		},
		{
			title: "详细地址",
			dataIndex: "detailAddress",
			key: "detailAddress",
			align: "center",
		},
		{
			title: "状态",
			dataIndex: "status",
			key: "status",
			align: "center",
			slots: {
				customRender: "actionStatus",
				action: "actionStatus"
			},
		},
		{
			title: "联系人",
			dataIndex: "contacts",
			key: "contacts",
			align: "center",
		},
		{
			title: "联系电话",
			dataIndex: "contactNumber",
			key: "contactNumber",
			align: "center",
		},
		{
			title: "创建时间",
			dataIndex: "createTime",
			key: "createTime",
			align: "center",
			customRender: function(record) {
				var val = record.text;
				return val ? moment(val).format("yyyy-MM-DD HH:mm:ss") : "";
			},
		},
		{
			title: "操作",
			dataIndex: "tags",
			key: "tags",
			width: 150,
			align: "left",
			slots: {
				customRender: "actionTags",
				action: "actionTags"
			},
			
		},
	];
	import moment from "moment";
	import AdministrativeArea from "@/components/administrativeArea/administrativeArea.vue";
	import {
		edit,
		getOrgData,
		statusChange,
		getOrgDetail,
		del
	} from '@/api/system/organization'
	import {
		message
	} from "ant-design-vue";
	export default {
		name: "org",
		components: {
			AdministrativeArea
		},
		data() {
			return {
				dataSource: [],
				columns,
				orgForm: {
					orgName: undefined,
					orgStatus: undefined,
				},
				/*维护科室信息 */
				showOrgMaintain: false,
				isaddedit: true, //是否是添加
				maintianForm: {
					id: undefined,
					type: "1", //组织类型
					name: "", //名称
					parent: -1,
					parentType: 2, //上级组织类型
					address: "", //地区
					detailAddress: "", //详细地址
					status: 1, //状态
					contacts: "", //联系人
					contactNumber: "", //联系人电话
				},
			};
		},
		mounted() {
			this.getData();
		},
		methods: {
			btnSearch() {
				this.getData();
			},
			btnReset() {
				this.orgForm = {
					orgName: undefined,
					orgStatus: undefined
				};
			},
			maintainOrg() {
				var form = this.maintianForm;
				if (!form.address || form.address.length < 1) {
					message.error("请选择所在地区！");
					return;
				}
				form.parent = form.parent == null ? -1 : form.parent;
				pluginLists(0, 0, param).then((response) => {
					this.data = response.data.listObject.filter(item => item.pluginId > 1)
					this.data.forEach((ele) => {
						if (ele.cost) {
							ele.cost = ele.cost.toLocaleString()
						}
						ele.installTime = ele.installTime ?
							new Date(ele.installTime).format('yyyy-MM-dd hh:mm:ss') :
							'-'
					})
				})
				edit(form).then((res) => {
					this.getData();
					this.showOrgMaintain = false;
				})
				// this.$refs.orgRuls
				// 	.validate(["name", "address", "detailAddress"])
				// 	.then(() => {
				// 		this.$axios.post("/api/v1/structure/edit", form, true).then((res) => {
				// 			if (res.code == 0 || res.code == 200) {
				// 				this.getData();
				// 				this.showOrgMaintain = false;
				// 			}
				// 		});
				// 	})
				// 	.catch((e) => {});
			},
			getData() {
				this.dataSource = [];
				var param = {
					name: this.orgForm.orgName,
					status: this.orgForm.orgStatus,
				};
				getOrgData(param).then((res) => {
					var data = res.data;
					this.dataSource = data;
				})
			},
			orgChange(value, label, extra) {
				// <!-- 1体育局2运动中心3场馆 -->
				/*1、添加下级组织结构时，如选择的上级组织是体育局，下级组织类型可选择体育局/运动中心/场馆中心；如选择的上级组织是运动中心，下级组织类型只能是运动中心，默认选中；
				        如选择的上级组织是场馆中心，下级组织类型只能是场馆中心，默认选中
				  2、审核通过的场馆在组织架构中呈现，默认选中组织类型是场馆中心*/
				this.getOrgDetail(value).then((el) => {
					if (el.code == 0 || res.code == 200) {
						let type = el.data.type;
						this.maintianForm.parentType = type;
						if (type == 2 || type == 3) {
							this.maintianForm.type = String(type);
						} else {
							this.maintianForm.type = "1";
						}
					}
				});
			},
			getOrgDetail(id) {
				return new Promise((resolve, reason) => {
					var param = {
						id: id,
					};
					getOrgDetail(param).then((res) => {
						resolve(res)
					})
					// this.$axios.post("/api/v1/structure/findById", param).then((res) => {
					// 	resolve(res);
					// });
				});
			},
			handleMaintain(type, record) {
				if (type == "add") {
					this.isaddedit = true;
					this.maintianForm = {
						id: undefined,
						type: "1", //组织类型
						name: "", //名称
						parent: null,
						parentType: 1, //上级组织类型
						address: "", //地区
						detailAddress: "", //详细地址
						status: 1, //状态
						contacts: "", //联系人
						contactNumber: "", //联系人电话
					};
					this.showOrgMaintain = true;
				}
				if (type == "edit") {
					this.isaddedit = false;
					this.maintianForm = {
						id: record.id,
						type: String(record.type), //组织类型
						name: record.name, //名称
						parent: record.parent == -1 ? null : record.parent,
						parentType: 1, //上级组织类型
						address: record.address, //地区
						detailAddress: record.detailAddress, //详细地址
						status: record.status, //状态
						contacts: record.contacts, //联系人
						contactNumber: record.contactNumber, //联系人电话
					};
					if (record.parent != -1) {
						Promise.all([this.getOrgDetail(record.parent)]).then((el) => {
							if (el[0].code == 0 || res.code == 200) {
								let type = el[0].data.type;
								this.maintianForm.parentType = type;
							}
							this.showOrgMaintain = true;
						});
					}
					if (record.parent == -1) {
						this.showOrgMaintain = true;
					}
				}
			},
			//组织架构状态修改
			maintainStatus(record) {
				var id = record.id;
				var param = {
					id: id, //组织结构ID
					status: record.status, //状态1开启0禁用
				};
				statusChange(param).then((res) => {
					message.success("状态修改成功");
				})
			},
			handleDelete(record) {
				var id = record.id;
				var param = {
					id: id,
				};
				del(param).then((res) => {
					this.getData();
				})
			},
			orgFormTreeValue(treeValue) {
				this.maintianForm.address = treeValue;
			},
		},
	};
</script>

<style scoped>
</style>